import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL ?? "";
const CATALOGO = `${BACKEND_URL}/api/catalogo`;

export async function fetchCatalogoTipos() {
  const { data } = await axios.get(`${CATALOGO}/tipos`);
  return data;
}

export async function fetchCatalogoTaxonomia({ tipo }) {
  const { data } = await axios.get(`${CATALOGO}/taxonomia`, {
    params: { tipo },
  });
  return data;
}

export async function fetchCatalogoPartidas({ tipo, taxonomiaNodoId }) {
  const n = Number(taxonomiaNodoId);
  const { data } = await axios.get(`${CATALOGO}/partidas`, {
    params: {
      tipo,
      taxonomiaNodoId: Number.isFinite(n) ? n : taxonomiaNodoId,
    },
  });
  return data;
}

export async function fetchCatalogoPartidaDetalle({ tipo, codigoInferido }) {
  const { data } = await axios.get(
    `${CATALOGO}/partidas/${encodeURIComponent(codigoInferido)}/detalle`,
    { params: { tipo } },
  );
  return data;
}
